import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { Component, Input, OnInit, ViewEncapsulation, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-custom-radio',
  templateUrl: './custom-radio.component.html',
  styleUrls: ['./custom-radio.component.scss'],
})
export class CustomRadioComponent implements OnInit {

  selectedOptions: string[];
  selectedType: string;
  isBinary: boolean;

  icons = {
    check: faCheck
  }


  @Input() options: any[];
  @Input() formCtrlName: any;
  @Input() formGrp: FormGroup;

  @Output() changed = new EventEmitter();

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.setType();
    this.selectedOptions = [this.options[0].name];
    if(this.selectedOptions) {
    //   this.setIntialFormValue();
    //   this.setFormValue();
    }
  }

  setType() {
    if ((this.el.nativeElement as HTMLElement).hasAttribute('grid')) {
      this.selectedType = 'grid-list';
    }

    if ((this.el.nativeElement as HTMLElement).hasAttribute('binary')) {
      this.isBinary = true;
    }
  }
  

  change(option: any) {
    
    this.selectedOptions = [option.name];
    // this.setFormValue();
    this.changed.emit(option);
  }

  checkActive(option: string) {
    return this.selectedOptions.findIndex((x: any) => x === option) > -1;
  }

}
